import React, { useEffect, useRef } from "react";
import { MathfieldElement } from "mathlive";
import "./LatexInput.css";


function LatexInput({ value, onChange, multiline = false, height = "45px" }) {
  const ref = useRef();

  useEffect(() => {
    if (!ref.current) return;

    const mf = ref.current;

    // Set up mathfield value and options
    mf.value = value;
    mf.setOptions({
      smartMode: true,
      virtualKeyboardMode: "manual",
      inlineShortcuts: {
        // optional custom LaTeX shortcuts
        sq: "\\sqrt",
      },
      ...(multiline && {
        mode: "text", // allow new lines
        readOnly: false,
        smartFence: false,
        smartSuperscript: true,
      }),
    });

    // Input event listener
    const handleInput = () => {
      onChange(mf.value);
    };

    mf.addEventListener("input", handleInput);

    return () => {
      mf.removeEventListener("input", handleInput);
    };
  }, [value, onChange, multiline]);

  return (
    <math-field
      ref={ref}
      math-mode={multiline ? "text" : "math"} // ✅ Important for multi-line
      style={{
        width: "100%",
        height,
        fontSize: "1.1rem",
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "0.5rem",
        background: "#f9f9f9",
        lineHeight: "1.6",
        overflowY: "auto",
        whiteSpace: "pre-wrap",
      }}
    />
  );
}

export default LatexInput;
